import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { apiUrl, myFetchPost } from "../utility";
import { Form, Spinner, Button, Modal } from "react-bootstrap";
import "../css/SettingScreen.css";
import { getMessaging, getToken, deleteToken, isSupported } from "firebase/messaging";

const delay = (delay) => {
  return new Promise((res, rej) => {
    setTimeout(() => {
      res("finish");
    }, delay);
  });
};

const SettingScreen = (props) => {
  const { currentUser } = useAuth();

  const [screenOverlay, setScreenOverlay] = useState(false);

  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningTitle, setWarningTitle] = useState("");
  const [warningMessage, setWarningMessage] = useState("");

  const [emailSetting, setEmailSetting] = useState("3");
  const [webNotificationEnabled, setWebNotificationEnabled] = useState(false);

  const [isBrowserGranted, setIsBrowserGranted] = useState("default");
  const [isBrowserSupported, setIsBrowserSupported] = useState(false);

  const timer = useRef();

  useEffect(() => {
    currentUser
      .getIdToken()
      .then((token) => {
        const requestData = {};
        return myFetchPost(`${apiUrl}/chat/getnotification`, requestData, {
          Authorization: "Bearer " + token,
        });
      })
      .then((res) => {
        if (res.result == "success") {
          setEmailSetting(res.emailSetting);
          if (
            window.localStorage.getItem("fcmToken") &&
            window.localStorage.getItem("pushnotification") === "true"
          ) {
            const previousToken = window.localStorage.getItem("fcmToken");
            isSupported().then((isMessagingSupported) => {
              if (isMessagingSupported) {
                if (Notification.permission === "granted") {
                  const messaging = getMessaging();
                  getToken(messaging, {
                    vapidKey:
                      "BHIw2Juj5M2Y8l5atJxE-NDIpzdKWDVAVilnnN8DgBs8RrfqXLOewqwPteIli1L5oGh3NtQL21emL9XmS0_u5sw",
                  })
                    .then((currentToken) => {
                      if (currentToken) {
                        window.localStorage.setItem("fcmToken", currentToken);
                        return subscribeToServer(
                          "subscribe",
                          currentToken,
                          previousToken
                        );
                      } else {
                        alert(
                          "No registration token available. Request permission to generate one."
                        );
                      }
                    })
                    .then((res) => {
                      if (res.result == "success") {
                        setWebNotificationEnabled(true);
                      }
                    })
                    .catch((err) => {
                      //window.localStorage.setItem("pushnotification", false);
                      alert(
                        "請更改瀏覽器設定為「允許接收推送通知」才可接收通知.",
                        err
                      );
                    });
                }
              }
            }).catch((err) => {
              console.log('error: ', err);
            });
          }
        }
      });
  }, []);

  useEffect(() => {
    isSupported()
      .then((isMessagingSupported) => {
        if (isMessagingSupported) {
          setIsBrowserSupported(true);
          navigator.permissions
            .query({ name: "notifications" })
            .then(function (notificationPerm) {
              setIsBrowserGranted(notificationPerm.state);
              notificationPerm.onchange = function () {
                setIsBrowserGranted(notificationPerm.state);
              };
            });
        }
      })
      .catch(/* error */);
  }, []);

  const subscribeToServer = async (
    subscribeType,
    currentToken,
    previousToken = ""
  ) => {
    return currentUser.getIdToken().then((token) => {
      const requestData = {
        form_action: subscribeType,
        currentToken: currentToken,
        previousToken: previousToken,
        platform: "webapp",
      };
      if (subscribeType == "subscribe") {
        return myFetchPost(`${apiUrl}/notification/subscribe`, requestData, {
          Authorization: "Bearer " + token,
        });
      } else if (subscribeType == "unsubscribe") {
        return myFetchPost(`${apiUrl}/notification/unsubscribe`, requestData, {
          Authorization: "Bearer " + token,
        });
      }
    });
  };

  const handlePushNotificationEnableSwitch = async () => {
    clearTimeout(timer.current);

    const currentNotificationStatus = webNotificationEnabled;
    setWebNotificationEnabled(currentNotificationStatus);

    if (currentNotificationStatus) {
      /* disable push notification */
      setWebNotificationEnabled(false);
      try {
        window.localStorage.setItem("pushnotification", false);
        setScreenOverlay("isSubmitting");
        await delay(200);
        const previousToken = window.localStorage.getItem("fcmToken");
        const unsubscribeRes = await subscribeToServer(
          "unsubscribe",
          previousToken
        );
        if (unsubscribeRes.result == "success") {
          window.localStorage.removeItem("fcmToken");
          setScreenOverlay(false);
        }
      } catch (error) { }
    } else {
      // Check if the browser supports notifications
      if (!("Notification" in window)) {
        alert("此瀏覽器不支援通知功能。");
        return;
      }

      /* enable push notification */
      if (Notification.permission == "denied") {
        setWarningTitle("開啟 DCFever 通知功能");
        setWarningMessage(
          '1. 在瀏覽器的位址列中選擇鎖頭圖示 <i class="bi bi-lock-fill"></i>。<br>2. 找到 <i class="bi bi-bell-fill"></i> 通知，然後選擇「允許」。<br>3. 選擇下方的開啟。'
        );
        setShowWarningModal(true);
        setWebNotificationEnabled(false);
      } else {
        try {
          setScreenOverlay(
            Notification.permission == "default"
              ? "isBlackScreen"
              : "isSubmitting"
          );
          isSupported().then(async (isMessagingSupported) => {
            if (isMessagingSupported) {
              const permission = await Notification.requestPermission();
              //alert('after requestPermission: ' + permission)
              if (permission !== 'granted') {
                //alert('通知權限被拒絕。請在瀏覽器設置中允許通知。');
                setScreenOverlay(false);
                setWarningTitle("開啟 DCFever 通知功能");
                setWarningMessage(
                  '1. 在瀏覽器的位址列中選擇鎖頭圖示 <i class="bi bi-lock-fill"></i>。<br>2. 找到 <i class="bi bi-bell-fill"></i> 通知，然後選擇「允許」。<br>3. 選擇下方的開啟。'
                );
                setShowWarningModal(true);
                setWebNotificationEnabled(false);
                return;
              }

              const messaging = getMessaging();
              /* added to remove current token and then we can create a new one */
              //await deleteToken(messaging);
              /* await getToken will request permission if not granted */
              try {
                const currentToken = await getToken(messaging, {
                  vapidKey:
                    "BHIw2Juj5M2Y8l5atJxE-NDIpzdKWDVAVilnnN8DgBs8RrfqXLOewqwPteIli1L5oGh3NtQL21emL9XmS0_u5sw",
                });
                if (currentToken) {
                  await delay(200);
                  const previousToken = window.localStorage.getItem("fcmToken");
                  const subscribeRes = await subscribeToServer(
                    "subscribe",
                    currentToken,
                    previousToken
                  );

                  setScreenOverlay(false);

                  if (subscribeRes.result == "success") {
                    window.localStorage.setItem("fcmToken", currentToken);
                    window.localStorage.setItem("pushnotification", true);
                    setShowWarningModal(false);
                    setWebNotificationEnabled(true);
                  }
                } else {
                  alert(
                    "No registration token available. Request permission to generate one."
                  );
                }
              } catch (error) {
                setScreenOverlay(false);
                alert('未能成功處理你的請求，請重試! 如果問題持續，請聯絡我們。');
              }
            }
          });
        } catch (error) {
          setScreenOverlay(false);
          alert("請更改瀏覽器設定為「允許接收推送通知」才可接收通知..");
        }
      }
    }
  };

  const handleManualEnableNotification = async () => {
    try {
      const isMessagingSupported = await isSupported();
      if (isMessagingSupported) {
        const messaging = getMessaging();
        /* added to remove current token and then we can create a new one */
        await deleteToken(messaging);

        const currentToken = await getToken(messaging, {
          vapidKey:
            "BHIw2Juj5M2Y8l5atJxE-NDIpzdKWDVAVilnnN8DgBs8RrfqXLOewqwPteIli1L5oGh3NtQL21emL9XmS0_u5sw",
        });
        if (currentToken) {
          const subscribeRes = await subscribeToServer(
            "subscribe",
            currentToken,
            window.localStorage.getItem("fcmToken")
          );

          if (subscribeRes.result == "success") {
            window.localStorage.setItem("fcmToken", currentToken);
            window.localStorage.setItem("pushnotification", true);
            setShowWarningModal(false);
            setWebNotificationEnabled(true);
          }
        } else {
          alert(
            "No registration token available. Request permission to generate one."
          );
        }
      }
    } catch (error) {
      alert("請更改瀏覽器設定為「允許接收推送通知」才可接收通知...", error);
    }
  };

  const handleUpdateEmailSubmit = async (data) => {
    clearTimeout(timer.current);
    setEmailSetting(data);
    try {
      const token = await currentUser.getIdToken();

      setScreenOverlay("isSubmitting");
      const requestData = {
        emailSetting: data,
      };

      await delay(200);
      const res = await myFetchPost(
        `${apiUrl}/chat/updateemailnotification`,
        requestData,
        {
          Authorization: "Bearer " + token,
        }
      );
      setScreenOverlay(false);
      timer.current = setTimeout(() => {
        setScreenOverlay(false);
      }, 3000);
    } catch (error) {
      alert("未能成功處理你的請求，請重試");
    }
  };

  const radios = [
    { label: "所有對話及出價", value: "5" },
    { label: "大部份的對話及出價", value: "4" },
    { label: "預設的通知設定", value: "3" },
    { label: "只對部份對話及出價作出通知", value: "2" },
    { label: "停止接收通知", value: "1" },
  ];

  let browserNotificationMessage = null;
  if (!isBrowserSupported) {
    browserNotificationMessage = (
      <div style={{ color: "red", fontSize: "13px" }}>
        此瀏覽器不支援推送通知
      </div>
    );
  } else {
    if (isBrowserGranted == "denied") {
      browserNotificationMessage = (
        <div style={{ color: "red", fontSize: "12px" }}>
          你的瀏覽器必須先允許接收推送通知
        </div>
      );
    }
  }

  return (
    <div className="settingScreenWrap">
      <div className="settingScreenContent">
        <div className="settingFormHeaderWrap">
          <div className="settingFormHeader mb-2">通知選項</div>
          <div>
            當有新訊息時，我們可以瀏覽器推送及電子郵件方式傳送通知給你，讓你第一時間掌握最新的訊息。
          </div>
        </div>
        <Form>
          <div className="settingFormSubHeader mb-2">推送通知</div>
          <Form.Group className="mb-4">
            <div className="formLine">
              <Form.Check type="switch" className="formCheck">
                <div className="formCheckInner">
                  <Form.Check.Label htmlFor="web_notification">
                    瀏覽器推送通知
                    {browserNotificationMessage}
                  </Form.Check.Label>
                  <Form.Check.Input
                    type="checkbox"
                    id="web_notification"
                    checked={webNotificationEnabled}
                    disabled={!isBrowserSupported}
                    onChange={() => {
                      handlePushNotificationEnableSwitch();
                    }}
                    className="checkboxStyle"
                  ></Form.Check.Input>
                </div>
              </Form.Check>
            </div>
          </Form.Group>

          <div className="settingFormSubHeader mb-2">電郵通知設定</div>
          <Form.Group className="mb-4" controlId="email">
            {radios.map((radio, index) => (
              <div key={index} className="formLine">
                <Form.Check type="radio" className="formCheck">
                  <div className="formCheckInner">
                    <Form.Check.Label htmlFor={`email_${radio.value}`}>
                      {radio.label}
                    </Form.Check.Label>
                    <Form.Check.Input
                      type="radio"
                      id={`email_${radio.value}`}
                      value={radio.value}
                      label={radio.label}
                      checked={emailSetting === radio.value}
                      onChange={(e) =>
                        handleUpdateEmailSubmit(e.currentTarget.value)
                      }
                      key={radio.value}
                      className="radioStyle"
                    />
                  </div>
                </Form.Check>
              </div>
            ))}
          </Form.Group>
        </Form>
      </div>
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showWarningModal}
        onHide={() => {
          setShowWarningModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "18px" }}>{warningTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: warningMessage }} />
        </Modal.Body>
        <Modal.Footer>
          {!isBrowserGranted && <Button variant="secondary">開啟</Button>}
          {isBrowserGranted && (
            <Button
              variant="primary"
              onClick={() => {
                handleManualEnableNotification(false);
              }}
            >
              開啟
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      {screenOverlay == "isSubmitting" && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            position: "absolute",
            top: "0px",
            right: "0px",
            bottom: "0px",
            left: "0px",
          }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      {screenOverlay == "isBlackScreen" && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            position: "absolute",
            top: "0px",
            right: "0px",
            bottom: "0px",
            left: "0px",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            zIndex: 100000,
          }}
          onClick={() => {
            setScreenOverlay(false);
          }}
        ></div>
      )}
    </div>
  );
};

export default SettingScreen;
